import aws from 'services/aws';
const API = aws.API;
export const usePubnabLambdaServices = ({
  accessToken,
  sessionId,
  language,
  channel,
}) => {
  const apiName = 'sdmVirtualEventModeratorApi';
  const isChatSession = true;
  const login = async (clientData) => {
    const input = {
      authKey: createAuthKey(clientData.uuid, clientData.channel),
    };
    const res = await API.lambdaPost(apiName, '/login', input);
    return { ...res, ...input };
  };

  const isModerator = async () => {
    const input = {
      sessionId,
      accessToken,
    };
    const res = await API.lambdaPost(apiName, '/isChatModerator', input);
    return !!res?.message;
  };

  const purgeMessage = async (messageTimetoken, msg) => {
    const input = {
      sessionId,
      language,
      accessToken,
      isChatSession,
      messageTimetoken,
      channel,
      msg,
    };
    const res = await API.lambdaPost(apiName, '/deleteMessage', input);
    return res;
  };

  const kickUser = async (authKey) => {
    const input = {
      sessionId,
      language,
      accessToken,
      isChatSession,
      authKey,
    };
    const res = await API.lambdaPost(apiName, '/banUser', input);
    return res;
  };
  const restoreUser = async (authKey) => {
    const input = {
      sessionId,
      language,
      accessToken,
      isChatSession,
      authKey,
    };
    const res = await API.lambdaPost(apiName, '/unbanUser', input);
    return res;
  };

  const createAuthKey = (uuid, msgChannel) => {
    return `${uuid}-${msgChannel || channel}`;
  };

  const getInvitations = async () => {
    const input = {
      sessionId,
      accessToken,
      isChatSession,
      statusType: 'accepted',
    };
    const res = await API.lambdaPost(apiName, '/getChatInvitations', input);
    return res?.invitations;
  };

  const getInvitationsForUser = async () => {
    const input = {
      sessionId,
      accessToken,
    };
    const res = await API.lambdaPost(
      apiName,
      '/getChatAcceptedInvitations',
      input
    );
    return res?.invitations;
  };

  return {
    isModerator,
    purgeMessage,
    kickUser,
    restoreUser,
    login,
    createAuthKey,
    getInvitations,
    getInvitationsForUser,
  };
};
